import React from "react";

const AuthContext = React.createContext({
  loggedUser: {},
  validToken: false,
  error: undefined,
  token: null,
});

export default AuthContext;
